import usabilidadeDoSistemaProfessor from "../Pages/AdminPage/Usabilidade/UsabilidadeDoSistemaProfessorPage.vue";

export default [
  {
    path: "/usabilidade/usabilidadeDoSistemaProfessor",
    name: "usabilidade.usabilidadeDoSistemaProfessor",
    component: usabilidadeDoSistemaProfessor,
  },
];
